import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import PivotConfiguratorProps from './PivotConfiguratorProps'

import Messages from './Messages'
import Sortable from '../Common/Sortable'

export default {
    props: PivotConfiguratorProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent, 
        KendoBaseDatasourceComponent, 
        Messages, 
        Sortable
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoPivotConfigurator(this.widgetOptions)
        if(this.v3) {
            this.ready()
        }
        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoPivotConfigurator()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-pivotgrid-vue-wrapper/src/KendoPivotConfigurator/KendoPivotConfiguratorMixin.js